import React, { SVGProps } from 'react'
const SvgDepartmentsEmptyState = (
  props: SVGProps<SVGSVGElement>,
): React.ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={109}
    height={109}
    fill="none"
    aria-hidden="true"
    {...props}
  >
    <g filter="url(#DepartmentsEmptyState_svg__a)">
      <path
        fill="#F6F7FB"
        fillRule="evenodd"
        d="M102 52.5c0 3.5-.382 6.9-1.107 10.18a47.004 47.004 0 0 1-.876 3.4c-.765 2.55-1.741 5-2.899 7.35-.342.7-.704 1.39-1.087 2.06l-.01.01a45.023 45.023 0 0 1-3.875 5.88 47.128 47.128 0 0 1-3.654 4.21 48.505 48.505 0 0 1-7.66 6.36 49.26 49.26 0 0 1-5.134 2.98 47.568 47.568 0 0 1-12.33 4.19c-2.97.58-6.04.88-9.18.88a48.18 48.18 0 0 1-9.603-.96 47.773 47.773 0 0 1-17.454-7.37C16.613 84.48 9.124 73.21 7 60.16V44.84c.684-4.25 1.943-8.3 3.694-12.09.604-1.32 1.268-2.6 1.993-3.85A47.85 47.85 0 0 1 54.188 5C80.59 5 102 26.27 102 52.5Z"
        clipRule="evenodd"
      />
      <path
        fill="#2B88FF"
        d="M100.893 62.68a47.004 47.004 0 0 1-.876 3.4c-.765 2.55-1.741 5-2.899 7.35-.342.7-.704 1.39-1.087 2.06l-.01.01a45.023 45.023 0 0 1-3.875 5.88 47.126 47.126 0 0 1-3.654 4.21 48.506 48.506 0 0 1-7.66 6.36 49.25 49.25 0 0 1-5.134 2.98 47.57 47.57 0 0 1-12.33 4.19V54.55l35.522 7.13c.775.16 1.449.51 2.003 1Z"
      />
      <path
        fill="#3F93FF"
        d="M100.017 66.08c-.765 2.55-1.741 5-2.899 7.35-.342.7-.704 1.39-1.087 2.06l-.01.01a45.023 45.023 0 0 1-3.875 5.88 47.126 47.126 0 0 1-3.654 4.21 48.506 48.506 0 0 1-7.66 6.36 49.25 49.25 0 0 1-5.134 2.98 47.57 47.57 0 0 1-12.33 4.19V58.55l35.522 7.13c.402.08.775.21 1.127.4Z"
      />
      <path
        fill="#fff"
        d="M78.903 85.592H71.98a2.112 2.112 0 0 1-2.119-2.105c0-1.162.948-2.105 2.12-2.105h6.922c1.171 0 2.12.943 2.12 2.105a2.112 2.112 0 0 1-2.12 2.105Z"
        opacity={0.5}
      />
      <path
        fill="#fff"
        d="M80.832 91.95a49.27 49.27 0 0 1-5.133 2.98h-3.715a2.117 2.117 0 0 1-2.124-2.11c0-1.16.947-2.11 2.124-2.11H78.9c.866 0 1.6.51 1.933 1.24ZM78.903 75.762H71.98a2.112 2.112 0 0 1-2.119-2.105c0-1.162.948-2.105 2.12-2.105h6.922c1.171 0 2.12.943 2.12 2.105a2.112 2.112 0 0 1-2.12 2.105Z"
        opacity={0.25}
      />
      <path
        fill="#fff"
        d="M92.146 81.38a47.144 47.144 0 0 1-3.654 4.21h-.403a2.109 2.109 0 0 1-2.124-2.1c0-1.17.947-2.11 2.124-2.11h4.057Z"
        opacity={0.5}
      />
      <path
        fill="#fff"
        d="M97.118 73.43c-.342.7-.704 1.39-1.087 2.06l-.01.01c-.302.17-.644.26-1.017.26H88.09a2.109 2.109 0 0 1-2.124-2.1c0-1.17.947-2.11 2.124-2.11h6.915c1.097 0 1.993.82 2.114 1.88Z"
        opacity={0.25}
      />
      <path
        fill={props.fill || 'var(--color-highlight)'}
        d="M63.368 41.56v57.56c-2.97.58-6.04.88-9.18.88a48.18 48.18 0 0 1-9.603-.96 47.773 47.773 0 0 1-17.454-7.37C16.613 84.48 9.124 73.21 7 60.16V33.08c0-1.36.574-2.69 1.67-3.51a4.303 4.303 0 0 1 3.333-.79l.684.12 47.208 8.52a4.204 4.204 0 0 1 3.473 4.14Z"
      />
      <path
        fill="#36C0A3"
        d="M63.368 45.56v53.56c-2.97.58-6.04.88-9.18.88a48.18 48.18 0 0 1-9.603-.96 47.773 47.773 0 0 1-17.454-7.37C16.613 84.48 9.124 73.21 7 60.16V37.08c0-1.36.574-2.69 1.67-3.51a4.243 4.243 0 0 1 2.024-.82c.433-.06.876-.05 1.309.03l47.892 8.64a4.204 4.204 0 0 1 3.473 4.14Z"
      />
      <path
        fill="#F6F7FB"
        fillRule="evenodd"
        d="M44.585 91.36v7.68a47.773 47.773 0 0 1-17.454-7.37v-.31c0-1.92 1.903-3.48 4.248-3.48h8.969c2.335 0 4.237 1.56 4.237 3.48Z"
        clipRule="evenodd"
      />
      <path
        fill="#fff"
        d="M31.017 73.92c0 1.16-.947 2.1-2.114 2.1h-8.475c-1.168 0-2.124-.94-2.124-2.1 0-1.16.956-2.11 2.124-2.11h8.475c1.168 0 2.114.95 2.114 2.11ZM31.017 61.29c0 1.16-.947 2.1-2.114 2.1h-8.475c-1.168 0-2.124-.94-2.124-2.1 0-1.17.956-2.11 2.124-2.11h8.475c1.168 0 2.114.94 2.114 2.11Z"
      />
      <path
        fill="#9ADED0"
        d="M31.017 48.65c0 1.17-.947 2.11-2.114 2.11h-8.475a2.117 2.117 0 0 1-2.124-2.11c0-1.16.956-2.1 2.124-2.1h8.475c1.168 0 2.114.94 2.114 2.1ZM52.497 73.92c0 1.16-.946 2.1-2.124 2.1h-8.475a2.107 2.107 0 0 1-2.114-2.1c0-1.16.946-2.11 2.114-2.11h8.475c1.178 0 2.124.95 2.124 2.11ZM52.497 61.29c0 1.16-.946 2.1-2.124 2.1h-8.475a2.107 2.107 0 0 1-2.114-2.1c0-1.17.946-2.11 2.114-2.11h8.475c1.178 0 2.124.94 2.124 2.11Z"
      />
      <path
        fill="#fff"
        d="M52.497 48.65c0 1.17-.946 2.11-2.124 2.11h-8.475a2.109 2.109 0 0 1-2.114-2.11c0-1.16.946-2.1 2.114-2.1h8.475c1.178 0 2.124.94 2.124 2.1Z"
      />
      <mask
        id="DepartmentsEmptyState_svg__b"
        width={95}
        height={95}
        x={7}
        y={5}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: 'alpha',
        }}
      >
        <path
          fill="#F2F3F7"
          fillRule="evenodd"
          d="M102 52.5c0 3.5-.382 6.9-1.107 10.18a47.004 47.004 0 0 1-.876 3.4c-.765 2.55-1.741 5-2.899 7.35-.342.7-.704 1.39-1.087 2.06l-.01.01a45.023 45.023 0 0 1-3.875 5.88 47.128 47.128 0 0 1-3.654 4.21 48.505 48.505 0 0 1-7.66 6.36 49.26 49.26 0 0 1-5.134 2.98 47.568 47.568 0 0 1-12.33 4.19c-2.97.58-6.04.88-9.18.88a48.18 48.18 0 0 1-9.603-.96 47.773 47.773 0 0 1-17.454-7.37C16.613 84.48 9.124 73.21 7 60.16V44.84c.684-4.25 1.943-8.3 3.694-12.09.604-1.32 1.268-2.6 1.993-3.85A47.85 47.85 0 0 1 54.188 5C80.59 5 102 26.27 102 52.5Z"
          clipRule="evenodd"
        />
      </mask>
      <g mask="url(#DepartmentsEmptyState_svg__b)">
        <g filter="url(#DepartmentsEmptyState_svg__c)">
          <path
            fill="#35BEA1"
            d="M68.967 98c-1.888-8.333.944-12.5 8.493-12.5s10.38 4.167 8.493 12.5"
          />
          <path
            fill="#9ADED0"
            d="M77.46 89.25c3.002 0 5.435-2.518 5.435-5.625S80.462 78 77.46 78s-5.436 2.518-5.436 5.625 2.434 5.625 5.436 5.625Z"
          />
        </g>
        <g filter="url(#DepartmentsEmptyState_svg__d)">
          <path
            fill="#6EACFC"
            d="M34.743 100c-1.887-8.333.944-12.5 8.493-12.5 7.55 0 10.38 4.167 8.493 12.5"
          />
          <path
            fill="#2B88FF"
            d="M43.236 91.25c3.002 0 5.436-2.518 5.436-5.625S46.238 80 43.236 80s-5.435 2.518-5.435 5.625 2.433 5.625 5.435 5.625Z"
          />
        </g>
        <g filter="url(#DepartmentsEmptyState_svg__e)">
          <path
            fill="#EAEBF1"
            d="M51.855 102c-1.887-8.333.944-12.5 8.493-12.5 7.55 0 10.38 4.167 8.493 12.5"
          />
          <path
            fill="#F6F7FB"
            d="M60.348 93.25c3.002 0 5.435-2.518 5.435-5.625S63.35 82 60.348 82s-5.436 2.518-5.436 5.625 2.434 5.625 5.436 5.625Z"
          />
        </g>
      </g>
    </g>
    <defs>
      <filter
        id="DepartmentsEmptyState_svg__a"
        width={109}
        height={109}
        x={0}
        y={0}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3.5} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_11750_392"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_11750_392"
          result="shape"
        />
      </filter>
      <filter
        id="DepartmentsEmptyState_svg__c"
        width={20.118}
        height={22}
        x={67.401}
        y={77}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset />
        <feGaussianBlur stdDeviation={0.5} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_11750_392"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_11750_392"
          result="shape"
        />
      </filter>
      <filter
        id="DepartmentsEmptyState_svg__d"
        width={20.118}
        height={22}
        x={33.177}
        y={79}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset />
        <feGaussianBlur stdDeviation={0.5} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_11750_392"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_11750_392"
          result="shape"
        />
      </filter>
      <filter
        id="DepartmentsEmptyState_svg__e"
        width={20.118}
        height={22}
        x={50.289}
        y={81}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset />
        <feGaussianBlur stdDeviation={0.5} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_11750_392"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_11750_392"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
)
export default SvgDepartmentsEmptyState
